// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let AlertAction =
{
    PLACE_ORDER_NOTIFY: 0,
    NOTIFY: 1,   //Значение по умолчанию
}

export let AlertEvent = {
    DELETED: 1,
    EXECUTED: 2,
    EXPIRED: 3,
    CREATED: 4,
    MODIFIED: 5,
    RESTARTED: 6
}

export let AlertStatus = {
    ACTIVE: 0,
    NOT_ACTIVE: 1
}

//избражение для кнопок в таблице
export let AlertSubImage = {
    PLAY_STOP: 0,
    UPDATE: 1,
    CLOSE: 2
}

export let AlertActions =
{
    START: 0,
    STOP: 1,
    DELETE: 2
}